// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdatePasswordNative_wrapper__7XHFl","wrapper__content":"UpdatePasswordNative_wrapper__content__mEZl-"};